<template>
  <div class="pin-wrap">
    <div class="form-title">
      保单信息
      <div class="renewalState">
        <span class="renewalState__label">当前进度</span><Tag :color="colorMap[formData.renewalState]">{{ formData.renewalState | renewalStateFilter }}</Tag>
      </div>
    </div>
    <FormItem label="保单编号：">
      <span class="descrypt-text" @dblclick="openEye(formData, 'policyNo')">{{ formData.policyNo }}</span>
      <a v-if="formData.policyNo" style="position: absolute; color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowpolicyNo" @click="openEye(formData, 'policyNo')"></i> </a
    ></FormItem>
    <FormItem label="保单状态：">{{ formData.policyInfo.policyStatus | policyStatusFilter }}</FormItem>
    <template v-if="$units.isSelfOrg(formData.policyInfo)">
      <FormItem label="投保人：">
        <span class="descrypt-text" @dblclick="openEye(formData.policyInfo, 'name')">{{ formData.policyInfo.name }}</span>
        <a v-if="formData.policyInfo.name" style="position: absolute; color: #2d8cf0 !important">
          <i class="iconfont iconyincang eye-icon eye" v-if="!formData.policyInfo.eyeShowname" @click="openEye(formData.policyInfo, 'name')"></i> </a
      ></FormItem>
      <FormItem label="受保人：">
        <span class="descrypt-text" @dblclick="openEye(formData.policyInfo, 'insuranceName')">{{ formData.policyInfo.insuranceName }}</span>
        <a v-if="formData.policyInfo.insuranceName" style="position: absolute; color: #2d8cf0 !important">
          <i
            class="iconfont iconyincang eye-icon eye"
            v-if="!formData.policyInfo.eyeShowinsuranceName"
            @click="openEye(formData.policyInfo, 'insuranceName')"
          ></i> </a></FormItem
    ></template>
    <FormItem label="保险公司：">{{ formData.policyInfo.companyName }}</FormItem>
    <FormItem label="产品名称：">{{ formData.policyInfo.productName }}</FormItem>
    <FormItem label="签单日期：">{{ formData.policyInfo.signDate | dateStrFilter }}</FormItem>
    <FormItem label="保单生效日期：">{{ formData.policyInfo.effectDate | dateStrFilter }}</FormItem>
    <FormItem label="缴费年期：">{{ formData.policyInfo.paymentPeriod }} <lzDicTxt v-if="formData.policyInfo.paymentType" :dicCode="formData.policyInfo.paymentType" dicType="GUARANTEE_TYPE"></lzDicTxt><span v-else>年</span></FormItem>
    <FormItem label="年缴保费单位：">{{ formData.policyInfo.currencyType | currencyTypeFilter }}</FormItem>
    <FormItem :label="isIFA ? '归属团队：' : '归属转介人：'">{{ formData.policyInfo.orgName }}</FormItem>
    <FormItem v-if="!formData.id || (formData.id && formData.tenantId === userInfo.tenantId)" label="归属员工：">{{ formData.policyInfo.agentName }}</FormItem>

    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import validUserName from '@/components/commons/validUserName';
import lzDicTxt from '@/components/commons/lzDicTxt';
import { common } from '@/api/mixins';
const policyStatusDic = JSON.parse(localStorage.dic)['POLICY_STATUS']; // 保单状态

const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};

export default {
  mixins: [common],
  props: ['formData'],
  components: {
    validUserName,
    lzDicTxt
  },
  data() {
    return {
      userInfo,
      policyStatusDic, // 保单状态
      productList: [],
      colorMap: {
        0: 'blue',
        1: 'blue',
        2: 'orange',
        3: 'orange',
        4: 'orange',
        5: 'green',
        6: 'red',
        7: 'red',
      }
    };
  },
  computed: {
    isIFA() {
      return this.userInfo.isIFA;
    }
  },
  filters: {
    policyStatusFilter(val) {
      if (!val) {
        return '-';
      }
      return policyStatusDic[val];
    },
    renewalStateFilter(val) {
      switch (val * 1) {
        case 0:
          return '未缴费';
        case 1:
          return '未缴费';
        case 2:
          return '已添加对账申请';
        case 3:
          return '已添加对账申请';
        case 4:
          return '保司已入账';
        case 5:
          return '续期成功';
        case 6:
          return '保费逾期';
        case 7:
          return '已失效';
        default:
          return '-';
      }
    },
    currencyTypeFilter(val) {
      if (!val) {
        return '-';
      }
      switch (val * 1) {
        case 1:
          return '港币';
        case 2:
          return '美元';
        case 3:
          return '人民币';
        default:
          return '-';
      }
    },
    dateStrFilter(val) {
      if (!val) {
        return '-';
      }
      return val.substring(0, 10);
    }
  },
  methods: {
    openEye(row, code) {
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code)
        return;
      }
      if (!row['eyeShow' + code]) {
        let operationType = {
          // 1-证件号解密  2-手机号解密 3-银行卡号 4-邮箱  5-通讯地址   6-身份证地址 7-居住地地址 8-通行证/护照号码 9-公司/学校名称 10-公司/学校地址
          idcardNo: 1,
          mobile: 2,
          idcardAddr: 6,
          currentAddr: 7,
          postalAddr: 5,
          passportCode: 8,
          company: 9,
          address: 10,
          policyNo: 11,
          name: 12,
          insuranceName: 12
        };
        let customerType = {
          name: 1,
          insuranceName: 2
        };
        this.descrypt(
          {
            customerType: customerType[code], //投保人
            query: this.formData.id,
            operationType: operationType[code],
            operationFunction: 7
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.renewalState {
  display: flex;
  align-items: center;
  font-weight: normal;
  font-size: 0.8em;
  position: absolute;
  right: 160px;
  bottom: 60%;
  background-color: #fff;
  .renewalState__label {
    padding-right: 6px;
  }
}
</style>
